/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Stefan Goessner - 2017-20. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
'use strict';

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function texmath(md, options) {
  var delimiters = options && options.delimiters || 'dollars';
  var katexOptions = options && options.katexOptions || {
    throwOnError: false
  };
  katexOptions.macros = options && options.macros || katexOptions.macros; // ensure backwards compatibility

  if (!texmath.katex) {
    // else ... depricated `use` method was used ...
    if (options && typeof options.engine === 'object') {
      texmath.katex = options.engine;
    } else if (typeof module === "object") texmath.katex = require('katex');else // artifical error object.
      texmath.katex = {
        renderToString: function renderToString() {
          return 'No math renderer found.';
        }
      };
  }

  if (delimiters in texmath.rules) {
    var _iterator = _createForOfIteratorHelper(texmath.rules[delimiters].inline),
        _step;

    try {
      var _loop = function _loop() {
        var rule = _step.value;
        md.inline.ruler.before('escape', rule.name, texmath.inline(rule)); // ! important

        md.renderer.rules[rule.name] = function (tokens, idx) {
          return rule.tmpl.replace(/\$1/, texmath.render(tokens[idx].content, !!rule.displayMode, katexOptions));
        };
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var _iterator2 = _createForOfIteratorHelper(texmath.rules[delimiters].block),
        _step2;

    try {
      var _loop2 = function _loop2() {
        var rule = _step2.value;
        md.block.ruler.before('fence', rule.name, texmath.block(rule)); // ! important for ```math delimiters

        md.renderer.rules[rule.name] = function (tokens, idx) {
          return rule.tmpl.replace(/\$2/, tokens[idx].info) // equation number .. ?
          .replace(/\$1/, texmath.render(tokens[idx].content, true, katexOptions));
        };
      };

      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        _loop2();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
} // texmath.inline = (rule) => dollar;  // just for debugging/testing ..


texmath.inline = function (rule) {
  return function (state, silent) {
    var pos = state.pos;
    var str = state.src;
    var pre = str.startsWith(rule.tag, rule.rex.lastIndex = pos) && (!rule.pre || rule.pre(str, pos)); // valid pre-condition ...

    var match = pre && rule.rex.exec(str);
    var res = !!match && pos < rule.rex.lastIndex && (!rule.post || rule.post(str, rule.rex.lastIndex - 1));

    if (res) {
      if (!silent) {
        var token = state.push(rule.name, 'math', 0);
        token.content = match[1];
        token.markup = rule.tag;
      }

      state.pos = rule.rex.lastIndex;
    }

    return res;
  };
};

texmath.block = function (rule) {
  return function block(state, begLine, endLine, silent) {
    var pos = state.bMarks[begLine] + state.tShift[begLine];
    var str = state.src;
    var pre = str.startsWith(rule.tag, rule.rex.lastIndex = pos) && (!rule.pre || rule.pre(str, pos)); // valid pre-condition ....

    var match = pre && rule.rex.exec(str);
    var res = !!match && pos < rule.rex.lastIndex && (!rule.post || rule.post(str, rule.rex.lastIndex - 1));

    if (res && !silent) {
      // match and valid post-condition ...
      var endpos = rule.rex.lastIndex - 1;
      var curline;

      for (curline = begLine; curline < endLine; curline++) {
        if (endpos >= state.bMarks[curline] + state.tShift[curline] && endpos <= state.eMarks[curline]) // line for end of block math found ...
          break;
      } // "this will prevent lazy continuations from ever going past our end marker"
      // s. https://github.com/markdown-it/markdown-it-container/blob/master/index.js


      var lineMax = state.lineMax;
      var parentType = state.parentType;
      state.lineMax = curline;
      state.parentType = 'math';
      if (parentType === 'blockquote') // remove all leading '>' inside multiline formula
        match[1] = match[1].replace(/(\n*?^(?:\s*>)+)/gm, ''); // begin token

      var token = state.push(rule.name, 'math', 1); // 'math_block'

      token.block = true;
      token.markup = rule.tag;
      token.content = match[1];
      token.info = match[match.length - 1]; // eq.no

      token.map = [begLine, curline]; // end token

      token = state.push(rule.name + '_end', 'math', -1);
      token.block = true;
      token.markup = rule.tag;
      state.parentType = parentType;
      state.lineMax = lineMax;
      state.line = curline + 1;
    }

    return res;
  };
};

texmath.render = function (tex, displayMode, options) {
  options.displayMode = displayMode;
  var res;

  try {
    res = texmath.katex.renderToString(tex, options);
  } catch (err) {
    res = tex + ": " + err.message.replace("<", "&lt;");
  }

  return res;
}; // ! deprecated ... use options !


texmath.use = function (katex) {
  // math renderer used ...
  texmath.katex = katex; // ... katex solely at current ...

  return texmath;
};
/*
function dollar(state, silent) {
  var start, max, marker, matchStart, matchEnd, token,
      pos = state.pos,
      ch = state.src.charCodeAt(pos);

  if (ch !== 0x24) { return false; }  // $

  start = pos;
  pos++;
  max = state.posMax;

  while (pos < max && state.src.charCodeAt(pos) === 0x24) { pos++; }

  marker = state.src.slice(start, pos);

  matchStart = matchEnd = pos;

  while ((matchStart = state.src.indexOf('$', matchEnd)) !== -1) {
    matchEnd = matchStart + 1;

    while (matchEnd < max && state.src.charCodeAt(matchEnd) === 0x24) { matchEnd++; }

    if (matchEnd - matchStart === marker.length) {
      if (!silent) {
        token         = state.push('math_inline', 'math', 0);
        token.markup  = marker;
        token.content = state.src.slice(pos, matchStart)
                                 .replace(/[ \n]+/g, ' ')
                                 .trim();
      }
      state.pos = matchEnd;
      return true;
    }
  }

  if (!silent) { state.pending += marker; }
  state.pos += marker.length;
  return true;
};
*/
// used for enable/disable math rendering by `markdown-it`


texmath.inlineRuleNames = ['math_inline', 'math_inline_double'];
texmath.blockRuleNames = ['math_block', 'math_block_eqno'];

texmath.$_pre = function (str, beg) {
  var prv = beg > 0 ? str[beg - 1].charCodeAt(0) : false;
  return !prv || prv !== 0x5c // no backslash,
  && (prv < 0x30 || prv > 0x39); // no decimal digit .. before opening '$'
};

texmath.$_post = function (str, end) {
  var nxt = str[end + 1] && str[end + 1].charCodeAt(0);
  return !nxt || nxt < 0x30 || nxt > 0x39; // no decimal digit .. after closing '$'
};

texmath.rules = {
  brackets: {
    inline: [{
      name: 'math_inline',
      rex: new RegExp("\\\\\\((.+?)\\\\\\)", "gy"),
      tmpl: '<eq>$1</eq>',
      tag: '\\('
    }],
    block: [{
      name: 'math_block_eqno',
      rex: new RegExp("\\\\\\[(((?!\\\\\\]|\\\\\\[)[\\s\\S])+?)\\\\\\]\\s*?\\(([^)$\\r\\n]+?)\\)", "gmy"),
      tmpl: '<section class="eqno"><eqn>$1</eqn><span>($2)</span></section>',
      tag: '\\['
    }, {
      name: 'math_block',
      rex: new RegExp("\\\\\\[([\\s\\S]+?)\\\\\\]", "gmy"),
      tmpl: '<section><eqn>$1</eqn></section>',
      tag: '\\['
    }]
  },
  gitlab: {
    inline: [{
      name: 'math_inline',
      rex: new RegExp("\\$`(.+?)`\\$", "gy"),
      tmpl: '<eq>$1</eq>',
      tag: '$`'
    }],
    block: [{
      name: 'math_block_eqno',
      rex: /`{3}math\s*([^`]+?)\s*?`{3}\s*\(([^)\r\n]+?)\)/gm,
      tmpl: '<section class="eqno"><eqn>$1</eqn><span>($2)</span></section>',
      tag: '```math'
    }, {
      name: 'math_block',
      rex: /`{3}math\s*([^`]*?)\s*`{3}/gm,
      tmpl: '<section><eqn>$1</eqn></section>',
      tag: '```math'
    }]
  },
  julia: {
    inline: [{
      name: 'math_inline',
      rex: new RegExp("`{2}([^`]+?)`{2}", "gy"),
      tmpl: '<eq>$1</eq>',
      tag: '``'
    }, {
      name: 'math_inline',
      rex: new RegExp("\\$((?:\\S?)|(?:\\S.*?\\S))\\$", "gy"),
      tmpl: '<eq>$1</eq>',
      tag: '$',
      pre: texmath.$_pre,
      post: texmath.$_post
    }],
    block: [{
      name: 'math_block_eqno',
      rex: new RegExp("`{3}math\\s+?([^`]+?)\\s+?`{3}\\s*?\\(([^)$\\r\\n]+?)\\)", "gmy"),
      tmpl: '<section class="eqno"><eqn>$1</eqn><span>($2)</span></section>',
      tag: '```math'
    }, {
      name: 'math_block',
      rex: new RegExp("`{3}math\\s+?([^`]+?)\\s+?`{3}", "gmy"),
      tmpl: '<section><eqn>$1</eqn></section>',
      tag: '```math'
    }]
  },
  kramdown: {
    inline: [{
      name: 'math_inline',
      rex: new RegExp("\\${2}(.+?)\\${2}", "gy"),
      tmpl: '<eq>$1</eq>',
      tag: '$$'
    }],
    block: [{
      name: 'math_block_eqno',
      rex: new RegExp("\\${2}([^$]+?)\\${2}\\s*?\\(([^)\\s]+?)\\)", "gmy"),
      tmpl: '<section class="eqno"><eqn>$1</eqn><span>($2)</span></section>',
      tag: '$$'
    }, {
      name: 'math_block',
      rex: new RegExp("\\${2}([^$]+?)\\${2}", "gmy"),
      tmpl: '<section><eqn>$1</eqn></section>',
      tag: '$$'
    }]
  },
  dollars: {
    inline: [{
      name: 'math_inline_double',
      rex: new RegExp("\\${2}((?:\\S)|(?:\\S.*?\\S))\\${2}", "gy"),
      tmpl: '<section><eqn>$1</eqn></section>',
      tag: '$$',
      displayMode: true,
      pre: texmath.$_pre,
      post: texmath.$_post
    }, {
      name: 'math_inline',
      rex: new RegExp("\\$((?:\\S)|(?:\\S.*?\\S))\\$", "gy"),
      tmpl: '<eq>$1</eq>',
      tag: '$',
      pre: texmath.$_pre,
      post: texmath.$_post
    }],
    block: [{
      name: 'math_block_eqno',
      rex: new RegExp("\\${2}([^$]+?)\\${2}\\s*?\\(([^)\\s]+?)\\)", "gmy"),
      tmpl: '<section class="eqno"><eqn>$1</eqn><span>($2)</span></section>',
      tag: '$$'
    }, {
      name: 'math_block',
      rex: new RegExp("\\${2}([^$]+?)\\${2}", "gmy"),
      tmpl: '<section><eqn>$1</eqn></section>',
      tag: '$$'
    }]
  }
};
if (typeof module === "object" && module.exports) module.exports = texmath;